import(/* webpackMode: "eager" */ "/var/node/newtonik/master/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/node/newtonik/master/app/ui/components/cookie-drawer-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/node/newtonik/master/app/ui/components/logo/logo-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/node/newtonik/master/app/ui/components/navigation/sidebar.tsx");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/app/ui/components/store-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/node/newtonik/master/app/ui/components/utils/payment-status-checker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/node/newtonik/master/app/ui/components/utils/session-manager.tsx");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/app/ui/layout/footer.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/node/newtonik/master/app/ui/layout/header-container.tsx");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/app/ui/layout/main.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/node/newtonik/master/app/ui/providers/client-providers.tsx");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-accordion/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-alert-dialog/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-avatar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-checkbox/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-collapsible/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-context-menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-dialog/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-dropdown-menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-form/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-hover-card/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-label/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-menubar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-navigation-menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-popover/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-portal/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-progress/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-radio-group/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-scroll-area/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-select/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-slider/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-switch/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-tabs/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-toggle-group/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-toggle/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-toolbar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-tooltip/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar"] */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/avatar.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/callout.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/checkbox-cards.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/checkbox-group.js");
;
import(/* webpackMode: "eager", webpackExports: ["Checkbox"] */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/checkbox.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/context-menu.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/dropdown-menu.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/radio-group.js");
;
import(/* webpackMode: "eager", webpackExports: ["Radio"] */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/radio.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/segmented-control.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/select.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/text-field.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThemePanel"] */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/theme-panel.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/theme.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/node/newtonik/master/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/styles/theme.css");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Noto_Sans\",\"arguments\":[{\"weight\":[\"400\",\"700\"],\"subsets\":[\"latin\",\"cyrillic\"]}],\"variableName\":\"notoSans\"}");
